<template>
    <div>
        <div class='buy-container'>
            <ChangeQuantity :item_quantity='quantity' :product ='product' @updatedQuantityListener='updatedQuantity' />
            <Button class='add-cart-button' v-if='in_stock' :disabled='is_disabled' text='Lock It In' theme='green' @click='addToCart'/>
        </div>
        <div class='successfully-added-to-bag-container'>
            <Tooltip :tooltip_queue='tooltip_queue'/>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";

import Button from '@/ecom/components/buttons/Button.vue';
import NotifyWhenAvailableButton from '@/ecom/components/buttons/NotifyWhenAvailableButton.vue';
import ChangeQuantity from '@/ecom/components/cart/ChangeQuantity.vue';
import Tooltip from '@/ecom/components/popups/Tooltip.vue';

export default {
    components: {Button, ChangeQuantity, NotifyWhenAvailableButton, Tooltip},
    props: ['product', 'in_stock', 'variant_code'],
    emits: ['updatedCartListener'],
    data(){
        return{
            quantity: 1,
            tooltip_queue: [],
            is_disabled: false
        }
    },
    methods:{
        async addToCart(){
            let response = await fetch(`/api/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    product: this.product,
                    quantity: this.quantity,
                    type: 'increment_quantity'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.quantity = 1;
                if(!results.stock.in_stock) {
                    let out_of_stock_message = '';
                    if(results.stock.left_in_stock > 0) {
                        out_of_stock_message = 'There are only ' + results.stock.left_in_stock  + ' of this item left in stock';
                    } else if(results.stock.left_in_stock == 0){
                        out_of_stock_message = 'This item is out of stock';
                    }
                    this.tooltip_queue.push({text: out_of_stock_message});
                    this.is_disabled = true;
                } else {
                    this.tooltip_queue.push({text: 'Added to bag!'});
                }
                this.$emit('updatedCartListener');
            }
        },
        updatedQuantity(quantity){
            this.quantity = quantity;
        }
    },
    watch: {
        'variant_code' : function() {
            this.is_disabled = false
        }
    }
}
</script>

<style lang="scss" scoped>
.buy-container{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;
    text-align: center;
    justify-content: center;
}

.successfully-added-to-bag-container{
    display: flex;
    justify-content: center;
}
.add-cart-button{
    width: 200px;
}
</style>